<div class="empty-notifications">
	<div class="grey-background">
		<bp-icon class="green-bell" [icon]="'alert'" size="48" theme="regular"></bp-icon>
	</div>
	<div class="empty-notifications-text">{{ "notification_center_empty_title" | translate }}</div>
</div>
